import { Expose, Type } from "class-transformer";
import { ConfigureOnboardingRequirementItemDto } from "@/core/features/employee-onboarding/configure-onboarding-requirement-item.dto";

export class ConfigureOnboardingRequirementsDto {
  @Expose()
  @Type(() => ConfigureOnboardingRequirementItemDto)
  uploadRequirements?: ConfigureOnboardingRequirementItemDto[];

  @Expose()
  @Type(() => ConfigureOnboardingRequirementItemDto)
  signatureRequirements?: ConfigureOnboardingRequirementItemDto[];
}
